import { render, staticRenderFns } from "./TopicRT.vue?vue&type=template&id=e0ff9dd6&scoped=true"
import script from "./TopicRT.vue?vue&type=script&lang=js"
export * from "./TopicRT.vue?vue&type=script&lang=js"
import style0 from "./TopicRT.vue?vue&type=style&index=0&id=e0ff9dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ff9dd6",
  null
  
)

export default component.exports